import type { BuildingBlockNodeConfig } from '@nodeTypeConfig/configTypes';
import { identifierComponent } from '@nodeTypeConfig/helpers/editComponents/identifierComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';

import { selectOdetDevelopmentGoalorEindtermNode } from '@newStore/documentUI/transformContent/odetContentNodeSelectors';
import { descriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';

const CURRICULUM_ODET_DEVELOPMENT_GOAL: BuildingBlockNodeConfig = {
  nodeSelector: selectOdetDevelopmentGoalorEindtermNode,
  information: {
    single: 'Ontwikkelingsdoel',
    plural: 'Ontwikkelingsdoelen',
  },
  buildingBlocks: [],
  edit: [
    {
      ...identifierComponent,
      width: 2,
    },
    {
      ...titleComponent,
      width: 10,
    },
    {
      ...descriptionComponent,
      label: 'Omschrijving / Afbakening',
    },
  ],
  isCollapsible: false,
  documentViewIdentifier: 'o(p*)(.)i',
  onNewNodeDropped: {
    focusOnField: 'title',
  },
};

export default CURRICULUM_ODET_DEVELOPMENT_GOAL;
